module.exports = __webpack_public_path__ + "img/icon297.3612cad4.png";